import React, { useContext } from 'react';
import i18next from 'i18next';
import SspProviderContext from '../../../../../utils/SspProvider/context';
import SubpageWhite from '../../SubpageWhite';
import Teaserbox from '../../../../AutostadtTabComponents/Tiles/Teaserbox';
import Infobox from '../../../../AutostadtTabComponents/Tiles/Infobox';
import { Textlink } from '../../../../AutostadtTabComponents/Button';
import {
    breatheStringArray,
    dataNodesFromArray,
    disconnectStringArray,
    overnightStringArray,
    specialsStringArray,
    toursStringArray,
    enjoyStringArray,
} from '../../../../../utils/AutostadtContextHelpers';
import { useConfig } from '../../../../../utils/AutostadtContextProvider';
import { DataNode } from '../../../../../utils/PickUpTypes';
import { setOverlay } from '../../../../../utils/SspProvider/dispatchFunctions';
import { OverlayEnum } from '../../../../../enums';
import he from 'he';

export default function Details() {
    const store = useContext(SspProviderContext);
    const config = useConfig();
    const toursArray = dataNodesFromArray(config, toursStringArray);
    const overnightArray = dataNodesFromArray(config, overnightStringArray);
    const disconnectArray = dataNodesFromArray(config, disconnectStringArray);
    const breatheArray = dataNodesFromArray(config, breatheStringArray);
    const specialsArray = dataNodesFromArray(config, specialsStringArray);
    const enjoyArray = dataNodesFromArray(config, enjoyStringArray);

    function getDetailsArray(node?: DataNode | null) {
        switch (node?.titel) {
            case 'Führungen':
                return toursArray;
            case 'Übernachten':
                return overnightArray;
            case 'Genießen':
                return enjoyArray;
            case 'Abschalten':
                return disconnectArray;
            case 'Durchatmen':
                return breatheArray;
            case 'Specials':
                return specialsArray;
            default:
                return [];
        }
    }

    const detailsArray = getDetailsArray(store.state.detailsNode);
    const reservationArray = ['Lagune', 'Familienrestaurant AMano', 'Beef Club'];

    const restaurantUrls: Record<string, string> = {
        Lagune: 'https://www.opentable.de/booking/restref/availability?lang=de-DE&correlationId=27722ee4-142c-4f92-be34-7b75037db69a&restRef=321093&otSource=Restaurant%20website',
        'Familienrestaurant AMano':
            'https://www.opentable.de/booking/restref/availability?lang=de-DE&correlationId=fdd9de78-b1f6-48ab-abf6-803f71ed5ea7&restRef=321090&otSource=Restaurant%20website',
        'Beef Club':
            'https://www.opentable.de/booking/restref/availability?lang=de-DE&correlationId=47065b64-225d-4307-a4c4-95270bcba28e&restRef=292458&otSource=Restaurant%20website',
    };

    const happinessPlannerArray = [
        'Führungen',
        'Werktour kompakt',
        'Zeithaus',
        'Upgrade Festtag',
        // 'Upgrade Fahrspaß',
        'Upgrade Autotürme',
        // 'Upgrade Deluxe',
        'Übernachten',
        'Specials',
    ];

    return (
        <SubpageWhite
            title={store.state.detailsNode?.titel ?? ''}
            imageSrc={store.state.detailsNode?.bild_url}
            imageCredits={store.state.detailsNode?.bildText}
            subline={store.state.detailsNode?.secondline ?? ''}
            nestedSubpage={true}
        >
            <>
                <p className='body large' style={{ whiteSpace: 'pre-line' }}>
                    {he.decode(store.state.detailsNode?.content_full || '')}
                    {store.state.detailsNode?.titel === 'Übernachten' && (
                        <Textlink
                            color={'dark-blue'}
                            text={'Auf zur exklusiven Direktbuchung'}
                            svg={'#as-link-external'}
                            onClick={() => {
                                setOverlay(store, {
                                    enum: OverlayEnum.ExternalContent,
                                    media: 'https://app.marriott.com/reslink?id=1787665828472&key=GRP&app=resvlink ',
                                });
                            }}
                        ></Textlink>
                    )}
                </p>

                <>
                    {detailsArray.map((item: DataNode) => {
                        return (
                            <div key={item.titel}>
                                <Teaserbox
                                    size={'foldable'}
                                    key={item.titel}
                                    headline={item.titel}
                                    subline={item.secondline}
                                    text={item.teaser}
                                    asset={item.bild_url}
                                />
                            </div>
                        );
                    })}

                    {store.state.detailsNode?.titel === 'Durchatmen' && (
                        <video
                            src={'/AutostadtTab/durchatmen.webm'}
                            autoPlay={true}
                            playsInline={true}
                            muted={true}
                            loop={true}
                        ></video>
                    )}
                    {store.state.detailsNode && happinessPlannerArray.includes(store.state.detailsNode?.titel) && (
                        <Infobox headline={i18next.t('Curious')}>
                            {
                                <div>
                                    <p className='body large bold'>{i18next.t('HappinessPlanner')}</p>
                                    <p className='body large'>{i18next.t('InfoBoxHappinessPlannerText')}</p>
                                    <Textlink
                                        color='dark-blue'
                                        text={i18next.t('HappinessPlannerBtn')}
                                        onClick={() => {
                                            window.open('https://www.autostadt.de/planer', '_blank', 'noopener,noreferrer');
                                        }}
                                    />
                                    <p className='body large bold'>{i18next.t('Contact')}</p>
                                    <p className='body large'>{i18next.t('InfoBoxHappinessPlannerContact')}</p>
                                    <Textlink
                                        type={'svg-left'}
                                        color={'dark-blue'}
                                        text={i18next.t('InfoBoxHappinessPlannerPhoneNumber')}
                                        svg='#as-phone'
                                        onClick={() => {
                                            const numberWithoutSpaces = i18next
                                                .t('InfoBoxHappinessPlannerPhoneNumber')
                                                .replace(/\s+/g, '');
                                            window.location.href = `tel:${numberWithoutSpaces}`;
                                        }}
                                    />

                                    <Textlink
                                        type={'svg-left'}
                                        color={'dark-blue'}
                                        text={i18next.t('InfoBoxHappinessPlannerEmailAddress')}
                                        svg='#as-email'
                                        onClick={() => {
                                            const email = i18next.t('InfoBoxHappinessPlannerEmailAddress');
                                            window.location.href = `mailto:${email}`;
                                        }}
                                    />
                                </div>
                            }
                        </Infobox>
                    )}
                    {store.state.detailsNode && reservationArray.includes(store.state.detailsNode?.titel) && (
                        <Infobox headline={i18next.t('Information')}>
                            {
                                <div>
                                    <p className='body large bold'>{i18next.t('RestaurantReservation')}</p>
                                    <Textlink
                                        color='dark-blue'
                                        text={i18next.t('ReservationBtn')}
                                        svg='#as-link-external'
                                        onClick={() => {
                                            setOverlay(store, {
                                                enum: OverlayEnum.ExternalContent,
                                                media:
                                                    store.state.detailsNode?.titel &&
                                                    store.state.detailsNode.titel in restaurantUrls
                                                        ? restaurantUrls[store.state.detailsNode.titel]
                                                        : '',
                                            });
                                        }}
                                    />

                                    <p className='body large bold'>{i18next.t('Contact')}</p>

                                    <Textlink
                                        type={'svg-left'}
                                        color={'dark-blue'}
                                        text={i18next.t('RestaurantPhoneNumber')}
                                        svg='#as-phone'
                                        onClick={() => {
                                            const numberWithoutSpaces = i18next
                                                .t('RestaurantPhoneNumber')
                                                .replace(/\s+/g, '');
                                            window.location.href = `tel:${numberWithoutSpaces}`;
                                        }}
                                    />

                                    <Textlink
                                        type={'svg-left'}
                                        color={'dark-blue'}
                                        text={i18next.t('RestaurantMailAddress')}
                                        svg='#as-email'
                                        onClick={() => {
                                            const email = i18next.t('RestaurantMailAddress');
                                            window.location.href = `mailto:${email}`;
                                        }}
                                    />
                                </div>
                            }
                        </Infobox>
                    )}
                </>
            </>
        </SubpageWhite>
    );
}
